<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.积分获取方式管理") }}</span>
    </div>

    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button size="medium" round @click="createTarget">
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.新建") }}
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button size="medium" round @click.native="refresh">
            <i class="iconfont">&#xe667;</i>
            {{ $t("message.刷新") }}
          </el-button>
        </el-link>
      </div>
    </div>

    <!--筛选区域-->
    <div class="grid-content content-margin">
      <el-divider></el-divider>
      <table class="simpleRow" style="width: 100%">
        <tr>
          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">ID</span>
          </td>
          <td class="serachText">
            <el-input
              clearable
              v-model="filterBody.gainid"
              size="mini"
              placeholder="请输入"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">事件类型</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="filterBody.eventtype"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in eventTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">获取积分</span>
          </td>
          <td class="serachText">
            <el-input
              clearable
              placeholder="请输入"
              v-model="filterBody.point"
              size="mini"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">积分组</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="filterBody.groupid"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in pointGroupList"
                :key="item.groupid"
                :label="item.name"
                :value="item.groupid"
              >
              </el-option>
            </el-select>
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">触发类型</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="filterBody.triggertype"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in triggerTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
      </table>

      <table class="simpleRow" style="width: 100%">
        <tr>
          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">需触发次数</span>
          </td>
          <td class="serachText">
            <el-input
              v-model="filterBody.triggerparam"
              clearable
              prefix-icon="el-icon-search"
              size="mini"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">限制次数</span>
          </td>
          <td class="serachText">
            <el-input
              v-model="filterBody.intervallimit"
              clearable
              prefix-icon="el-icon-search"
              size="mini"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">限制类型</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="filterBody.intervaltype"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in intervalTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">限制间隔</span>
          </td>
          <td class="serachText">
            <el-input
              v-model="filterBody.interval"
              clearable
              prefix-icon="el-icon-search"
              size="mini"
            />
          </td>

          <td class="serachSpan">
            <span class="simpleLabel" style="float: right">状态</span>
          </td>
          <td class="serachText">
            <el-select
              v-model="filterBody.state"
              placeholder="请选择"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
      </table>

      <table class="simpleRow" style="width: 100%">
        <tr>
          <td style="width: 7%">
            <span class="simpleLabel" style="float: right">开始日期</span>
          </td>
          <td style="width: 9%">
            <el-select
              v-model="filterBody.fromdate.dateType"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="item in dateTypeOptions"
                :key="item.type"
                :label="item.label"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </td>

          <td v-if="filterBody.fromdate.dateType == 0" style="width: 24%"></td>

          <td
            style="width: 12%"
            v-if="
              filterBody.fromdate.dateType == 1 ||
              filterBody.fromdate.dateType == 3 ||
              filterBody.fromdate.dateType == 4 ||
              filterBody.fromdate.dateType == 7
            "
          >
            <span v-if="filterBody.fromdate.dateType == 7">从</span>
            <el-date-picker
              style="width: 85%"
              v-model="filterBody.fromdate.fromDate"
              value-format="timestamp"
              type="date"
              size="mini"
              placeholder="选择日期"
            >
            </el-date-picker>
          </td>

          <td
            style="width: 12%"
            v-if="
              filterBody.fromdate.dateType == 1 ||
              filterBody.fromdate.dateType == 3 ||
              filterBody.fromdate.dateType == 4
            "
          ></td>

          <td v-if="filterBody.fromdate.dateType == 7" style="width: 12%">
            <span>至</span>
            <el-date-picker
              style="width: 85%"
              v-model="filterBody.fromdate.toDate"
              value-format="timestamp"
              type="date"
              size="mini"
              placeholder="选择日期"
            >
            </el-date-picker>
          </td>

          <td v-if="filterBody.fromdate.dateType == 14" style="width: 12%">
            <span>在</span>
            <el-input-number
              v-model="filterBody.fromdate.nowDay"
              :min="1"
              size="mini"
              style="width: 75%"
            ></el-input-number>
            <span>天</span>
          </td>
          <td v-if="filterBody.fromdate.dateType == 14" style="width: 12%">
            <el-select v-model="filterBody.fromdate.nowType" size="mini">
              <el-option label="以内" :value="0"> </el-option>
              <el-option label="以外" :value="1"> </el-option>
            </el-select>
          </td>

          <td style="width: 7%">
            <span class="simpleLabel" style="float: right">结束日期</span>
          </td>
          <td style="width: 9%">
            <el-select
              v-model="filterBody.todate.dateType"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="item in dateTypeOptions"
                :key="item.type"
                :label="item.label"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </td>

          <td v-if="filterBody.todate.dateType == 0" style="width: 24%"></td>

          <td
            style="width: 12%"
            v-if="
              filterBody.todate.dateType == 1 ||
              filterBody.todate.dateType == 3 ||
              filterBody.todate.dateType == 4 ||
              filterBody.todate.dateType == 7
            "
          >
            <span v-if="filterBody.todate.dateType == 7">从</span>
            <el-date-picker
              style="width: 85%"
              v-model="filterBody.todate.fromDate"
              value-format="timestamp"
              type="date"
              size="mini"
              placeholder="选择日期"
            >
            </el-date-picker>
          </td>

          <td
            style="width: 12%"
            v-if="
              filterBody.todate.dateType == 1 ||
              filterBody.todate.dateType == 3 ||
              filterBody.todate.dateType == 4
            "
          ></td>

          <td v-if="filterBody.todate.dateType == 7" style="width: 12%">
            <span>至</span>
            <el-date-picker
              style="width: 85%"
              v-model="filterBody.todate.toDate"
              value-format="timestamp"
              type="date"
              size="mini"
              placeholder="选择日期"
            >
            </el-date-picker>
          </td>

          <td v-if="filterBody.todate.dateType == 14" style="width: 12%">
            <span>在</span>
            <el-input-number
              v-model="filterBody.todate.nowDay"
              :min="1"
              size="mini"
              style="width: 75%"
            ></el-input-number>
            <span>天</span>
          </td>
          <td v-if="filterBody.todate.dateType == 14" style="width: 12%">
            <el-select v-model="filterBody.todate.nowType" size="mini">
              <el-option label="以内" :value="0"> </el-option>
              <el-option label="以外" :value="1"> </el-option>
            </el-select>
          </td>

          <td>
            <el-button
              type="primary"
              size="mini"
              style="float: right"
              @click="refresh"
              >检索</el-button
            >
          </td>
          <td>
            <el-button size="mini" @click="resetFilterBody">清空</el-button>
          </td>
        </tr>
      </table>
    </div>

    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="pointGainList"
        stripe
        border
        :height="tableHeight"
        style="width: 100%"
      >
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editTarget(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-edit"
                @click="editTarget(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  targetRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="gainid"
          :label="$t('message.获取方式ID')"
          width="125"
        >
        </el-table-column>

        <el-table-column
          width="150"
          sortable
          :label="$t('message.事件类型')"
          prop="eventtype"
        >
          <template slot-scope="scope">
            <span>{{ getEventTypeName(scope.row.eventtype) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="point"
          :label="$t('message.获取积分')"
          width="125"
        >
        </el-table-column>

        <el-table-column
          width="150"
          sortable
          :label="$t('message.积分组')"
          prop="groupid"
        >
          <template slot-scope="scope">
            <span>{{ getGroupName(scope.row.groupid) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          width="150"
          sortable
          :label="$t('message.触发类型')"
          prop="triggertype"
        >
          <template slot-scope="scope">
            <span>{{ getTriggerType(scope.row.triggertype) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="triggerparam"
          :label="$t('message.需触发次数')"
          width="125"
        >
        </el-table-column>

        <el-table-column
          width="150"
          sortable
          :label="$t('message.限制次数')"
          prop="intervallimit"
        >
          <template slot-scope="scope">
            <span>{{ getIntervalLimit(scope.row.intervallimit) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="intervalType"
          :label="$t('message.限制类型')"
          width="125"
        >
          <template slot-scope="scope">
            <span>{{
              getIntervalLimitType(
                scope.row.intervallimit,
                scope.row.intervaltype
              )
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="interval"
          :label="$t('message.限制间隔')"
          width="125"
        >
          <template slot-scope="scope">
            <span>{{
              getInterval(
                scope.row.intervallimit,
                scope.row.intervaltype,
                scope.row.interval
              )
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="fromdate"
          :label="$t('message.开始日期')"
          width="200"
        >
        </el-table-column>

        <el-table-column
          sortable
          prop="todate"
          :label="$t('message.结束日期')"
          width="200"
        >
        </el-table-column>

        <el-table-column
          width="100"
          sortable
          :label="$t('message.状态')"
          prop="state"
        >
          <template slot-scope="scope">
            <span>{{ getStateName(scope.row.state) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="remarks"
          :label="$t('message.备注信息')"
          width="300"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          sortable
          prop="editdate"
          :label="$t('message.更新日期')"
          width="200"
        >
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination
        :pagesizeList="pageConfig.pagesizeList"
        :pagesize="pagingBody.pageConfig.pagesize"
        :total="pageConfig.total"
        :page="pagingBody.pageConfig.page"
      ></pagination>
    </div>

    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该获取方式") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
// 分页模块
import pagination from "@/components/pagination/pagination";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import eventType from "@/utils/EventType";

export default {
  name: "PointGainList",
  components: {
    pagination,
  },
  data() {
    return {
      //检索数据
      filterBody: {},

      tableHeight: 500,

      //获取列表
      pointGainList: [],
      pointGroupList: [],

      eventTypeOptions: [],

      triggerTypeOptions: [
        {
          value: 0,
          name: "单次触发获取",
        },
        {
          value: 1,
          name: "连续触发获取",
        },
      ],

      stateOptions: [
        {
          value: 0,
          name: "正常",
        },
        {
          value: 1,
          name: "禁用",
        },
      ],

      intervalTypeOptions: [
        { value: 0, name: "永久" },
        { value: 1, name: "按年" },
        { value: 2, name: "按月" },
        { value: 3, name: "按周" },
        { value: 4, name: "按天" },
      ],

      deleteDialogVisible: false,
      targetRow: null,

      // 分页
      pageConfig: {
        pagesizeList: [5, 20, 50, 100],
        total: null,
      },

      dateTypeOptions: [
        { label: "不启用", type: 0 },
        { label: "等于", type: 1 },
        { label: "大于", type: 3 },
        { label: "小于", type: 4 },
        { label: "区间", type: 7 },
        { label: "当前时间点", type: 14 },
      ],

      pagingBody: {
        appID: 188,
        filterConfig: {},
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {
          order: "",
          prop: "",
        },
      },
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    resetFilterBody() {
      this.filterBody = {
        gainid: "",
        eventtype: "",
        point: "",
        groupid: "",
        triggertype: "",
        triggerparam: "",
        intervallimit: "",
        intervaltype: "",
        interval: "",
        state: "",
        fromdate: {
          dateType: 0,
          fromDate: "",
          nowDay: 1,
          nowType: 0,
          toDate: "",
        },
        todate: {
          dateType: 0,
          fromDate: "",
          nowDay: 1,
          nowType: 0,
          toDate: "",
        },
      };
    },

    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/point/pointgrouplist",
        { appid: "188", search: "" },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            // 添加总条数
            this.pointGroupList = doc.data.data;
            this.pointGroupList.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
            });
          }
        }
      );

      this.pagingBody.filterConfig = JSON.parse(
        JSON.stringify(this.filterBody)
      );
      console.log("aaaaaaaaaaa", this.pagingBody);
      rejecthttp(
        true,
        "post",
        "/manage/point/pointgainlist",
        this.pagingBody,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);

            this.pageConfig.total = doc.data.exData.datas;
            this.pointGainList = doc.data.data;
            this.pointGainList.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
              if (any.fromdate != null) {
                any.fromdate = commonUtil.formatDate(any.fromdate);
              } else {
                any.fromdate = "无限制";
              }
              if (any.todate != null) {
                any.todate = commonUtil.formatDate(any.todate);
              } else {
                any.todate = "无限制";
              }
            });
          }
        }
      );
    },

    getEventTypeName(event) {
      for (let i = 0; i < this.eventTypeOptions.length; ++i) {
        if (this.eventTypeOptions[i].value == parseInt(event)) {
          return this.eventTypeOptions[i].name;
        }
      }

      return "未定义";
    },

    getGroupName(groupid) {
      for (let i = 0; i < this.pointGroupList.length; ++i) {
        if (this.pointGroupList[i].groupid == groupid) {
          return this.pointGroupList[i].name;
        }
      }

      return "未定义";
    },

    getTriggerType(triggerType) {
      for (var i = 0; i < this.triggerTypeOptions.length; ++i) {
        if (this.triggerTypeOptions[i].value == triggerType) {
          return this.triggerTypeOptions[i].name;
        }
      }
      return "未定义";
    },

    getIntervalLimit(intervalLimit) {
      if (intervalLimit > 0) {
        return intervalLimit;
      }
      return "无限制";
    },

    getIntervalLimitType(intervalLimit, intervalLimitType) {
      if (intervalLimit <= 0) {
        return "无限制";
      }

      for (var i = 0; i < this.intervalTypeOptions.length; ++i) {
        if (this.intervalTypeOptions[i].value == intervalLimitType) {
          return this.intervalTypeOptions[i].name;
        }
      }

      return "未定义";
    },

    getInterval(intervalLimit, intervalLimitType, interval) {
      if (intervalLimit <= 0) {
        return "无限制";
      }
      if (intervalLimitType <= 0) {
        return "永久";
      }
      return interval;
    },

    createTarget() {
      this.$router.push({ name: "pointGainDetail", query: { appid: "188" } });
    },

    editTarget(data, edit) {
      this.$router.push({
        name: "pointGainDetail",
        query: { id: data.gainid, appid: "188", isEditMode: edit },
      });
    },

    deleteTarget() {
      rejecthttp(
        true,
        "get",
        "/manage/point/deletepointgain",
        {
          appid: 188,
          gainid: this.targetRow.gainid,
        },
        this,
        (doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          }
          this.deleteDialogVisible = false;
          this.refresh();
        }
      );
    },
    getStateName(state) {
      return commonUtil.getStateName(state);
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.resetFilterBody();
    this.eventTypeOptions = eventType.getData();
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}

.serachSpan {
  width: 7%;
}
.serachText {
  width: 13%;
}
.serachInput {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointgainlist.vue